import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  template: `
<registration-page centered="true">
  <h1 id="qa-user-exists-header-msg">It looks like you already have a login.</h1>
  <p>You can use your existing New World Clubcard login and password to log in to I shop New World</p>
  <p class="qa-login-button">Press X above to close Sign-up and then logon</p>
</registration-page>
`
})
export class EmailRegisteredPage extends Vue {

}



// WEBPACK FOOTER //
// ./src/pages/messages/email-registered/email-registered.ts